import { gql } from 'graphql-tag';

export const CREATE_DISCOUNT_CODE = gql`
  mutation createDiscountCode($input: CreateDiscountCodeInput!) {
    createDiscountCode(input: $input) {
      discountCode {
        id
        code
      }
      errors
    }
  }
`;

export const UPDATE_DISCOUNT_CODE = gql`
  mutation updateDiscountCode($input: UpdateDiscountCodeInput!) {
    updateDiscountCode(input: $input) {
      discountCode {
        id
      }
    }
  }
`;

export const GET_DISCOUNT_CODE = gql`
  query getDiscountCode($id: Int!) {
    discountCode(id: $id) {
      category
      code
      discountAmount
      discountPercentage
      discountType
      expiresIn
      hasLimit
      id
      oncePerCustomer
      serviceIds
      state
      usageLimit
      validFrom
      validUntil
    }
  }
`;
